import { useCallback } from 'react';
import { useExecuteLogout } from '../../../../../hooks/useExecuteLogout';
import { useRouter } from '../../../useRouter';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

const useLogout = () => {
  const router = useRouter();
  const { onLogout: onExecuteLogout } = useExecuteLogout();

  const onLogout = useCallback(async () => {
    await onExecuteLogout();
    router.replace('/');
    return SHOULD_NOT_PROPAGATE_UP;
  }, [router, onExecuteLogout]);

  return { onLogout };
};

export default useLogout;
